module.exports = __webpack_public_path__ + "img/roll-875.f6195348.png";